(function () {

    'use strict';

    angular
        .module('auditMandateModule')
        .controller('AuditMandateAddController', Controller);

    Controller.$inject = ['$scope', 'topBarService', 'lookupAttributes'];

    function Controller($scope, topBarService, lookupAttributes) {
            
        topBarService.setTitleAndIcon('New Audit Mandate', 'fa fa-road');
        $scope.auditMandate = {};

        $scope.lookupAttributes = lookupAttributes;
    }
})();